import { createReducer } from '@reduxjs/toolkit';
import { loadI18n } from '../actions/loadI18n';
import { loadPaymentMethods } from '../actions/loadPaymentMethods';
import { RequestFailureReason } from '../types/RequestFailureReason';
import { checkApCanMakePayments } from '../actions/checkApCanMakePayments';
import { checkApHighestSupportedVersion } from '../actions/checkApHighestSupportedVersion';
import { loadPayPalScript } from '../actions/loadPayPalScript';
import { isAction } from './asyncMatchers';

export interface RequestStateMeta {
  requestPhase?: boolean;
  loading?: boolean;
  success?: boolean;
  error?: any;
  errorReason?: RequestFailureReason;
}
type StateMeta = 'loadI18n' | 'loadPaymentMethods' | 'loadPayPalScript';

export type RequestsState = Record<StateMeta, RequestStateMeta>;

export type AsyncStatus = 'idle' | 'pending' | 'fulfilled' | 'rejected';

export interface RequestState {
  loadI18n: AsyncStatus;
  loadPaymentMethods: AsyncStatus;
  loadPayPalScript: AsyncStatus;
  canMakePayments: AsyncStatus;
  highestSupportedApplePayVersion: AsyncStatus;
}
const initialState: RequestState = {
  loadI18n: 'idle',
  loadPaymentMethods: 'idle',
  loadPayPalScript: 'idle',
  canMakePayments: 'idle',
  highestSupportedApplePayVersion: 'idle',
};

export const requestsStateReducer = createReducer(initialState, (builder) => {
  builder.addMatcher(isAction(loadI18n), (state, action) => {
    state.loadI18n = action.meta.requestStatus;
  });
  builder.addMatcher(isAction(loadPaymentMethods), (state, action) => {
    state.loadPaymentMethods = action.meta.requestStatus;
  });
  builder.addMatcher(isAction(loadPayPalScript), (state, action) => {
    state.loadPayPalScript = action.meta.requestStatus;
  });
  builder.addMatcher(isAction(checkApCanMakePayments), (state, action) => {
    state.canMakePayments = action.meta.requestStatus;
  });
  builder.addMatcher(isAction(checkApHighestSupportedVersion), (state, action) => {
    state.highestSupportedApplePayVersion = action.meta.requestStatus;
  });
});
